import React, { useState } from 'react';
import Button from '../UI/button';
import { Dropdown } from 'react-bootstrap';
import {
  ISortBy,
  SortByLastUpdateRecentFirst
} from '../../Models/sortby.model';

type SortBy = {
  value: ISortBy;
  label: string;
};

interface SortByProps {
  sortByArray: SortBy[];
  handleClose: (selectedSortBy: ISortBy) => void;
  currentValue?: ISortBy;
}

const objectsAreEqual = (obj1: any, obj2: any) => {
  return JSON.stringify(obj1) === JSON.stringify(obj2);
};

const SortBy = ({ sortByArray, handleClose, currentValue }: SortByProps) => {
  const [sortBy, setSortBy] = useState<{ value: ISortBy; label: string }>({
    value: currentValue ?? { queryString: '', field: '', direction: '' },
    label: 'Select'
  });
  const [isOpen, setIsOpen] = useState(false);

  const handleSortBy = (value: { value: ISortBy; label: string }) => {
    console.log('sort by', value);
    setSortBy(value);
    setIsOpen(false);
  };

  const handleUseFilter = () => {
    console.log('sort by', sortBy.value);
    handleClose(sortBy.value);
  };

  return (
    <div className='sort-by-container'>
      <Dropdown
        show={isOpen}
        onToggle={() => setIsOpen(!isOpen)}
        style={isOpen ? { marginBottom: sortByArray.length * 35 + 24 } : {}}
      >
        <Dropdown.Toggle
          variant='outline-primary'
          id='dropdown-basic'
        >
          {sortBy.label}
          <svg
            width='18'
            height='11'
            viewBox='0 0 18 11'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M1 1L9 9L17 1'
              stroke='#842234'
              strokeWidth='round'
            />
          </svg>
        </Dropdown.Toggle>
        <Dropdown.Menu popperConfig={{ strategy: 'fixed' }} renderOnMount>
          {sortByArray.map((sortItem, index) => {
            return (
              <Dropdown.Item href='#/action-1'>
                <input
                  key={index}
                  type='radio'
                  name='sort-by'
                  id={index.toString()}
                  checked={objectsAreEqual(sortBy.value, sortItem.value)}
                  onChange={() => handleSortBy(sortItem)}
                />
                <label htmlFor={sortItem.value.field}>{sortItem.label}</label>
              </Dropdown.Item>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
      <Button
        width={171}
        className='mx-auto'
        style={{ marginTop: '24px' }}
        onClick={handleUseFilter}
      >
        Use Filter
      </Button>
    </div>
  );
};
export default SortBy;
